/**
 * Base64 decoding utility functions.
 * Some backend endpoints return binary file content (e.g. PDFs) encoded as a
 * base64 text string rather than raw bytes, so it must be decoded client-side
 * before it can be used as a valid Blob.
 */

/**
 * Decodes a base64-encoded string into a Blob with the given MIME type.
 * @param base64 - Base64-encoded file content (no data URI prefix)
 * @param mimeType - MIME type to assign to the resulting Blob (defaults to PDF)
 * @returns A Blob containing the decoded binary data
 */
export function base64ToBlob(base64: string, mimeType = 'application/pdf'): Blob {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: mimeType });
}
